module.exports = __webpack_public_path__ + "images/sgp/SGPHero/small-self-storage-hero.webp";